// Action types
export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';
export const SET_TIME_FILTER = 'SET_TIME_FILTER';

// Initial state
const initialState = {
  events: [],
  loading: false,
  error: null,
  timeFilter: 3600000, // 1 hour in milliseconds
};

// Reducer
const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        events: action.payload,
      };
    case FETCH_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SET_TIME_FILTER:
      return {
        ...state,
        timeFilter: action.payload,
      };
    default:
      return state;
  }
};

export default eventsReducer;